import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import { ShieldCheckIcon } from '@heroicons/react/24/solid';

const Navbar = () => {
  const { logout } = useContext(AuthContext);
  return (
    <nav className="bg-white shadow-sm sticky top-0 z-20">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center space-x-2 text-indigo-600 font-bold text-lg">
          <ShieldCheckIcon className="h-6 w-6" />
          <span>IRSAudit</span>
        </Link>
        <button onClick={logout} className="btn-secondary">Logout</button>
      </div>
    </nav>
  );
};

export default Navbar; 